import { JsonProperty, JsonObject } from 'typescript-json-serializer';

/**
 * Container class for QR code information
 *
 * @export
 * @class QrCode
 */
@JsonObject()
export class QrCode {
  @JsonProperty('DownloadUri') downloadUri: string;
  @JsonProperty('Code') code: string;
  @JsonProperty('DebugMessage') message: string;
}
